import { AuthN, getConfig } from '@seek/online-identity';

export default (): AuthN => new AuthN(getConfig('seekjobs', window.location));
